import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FlagRounded from '@mui/icons-material/FlagRounded';
import { Box, Button, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import useSurveySettings from 'src/hooks/useSurveySettings.ts';
import { routePaths } from 'src/services/routing/routePaths';
import { usePlanActionContext } from 'src/components/planAction/PlanActionContext';

import { styles } from './index.styles';

const OrgUnitHeader = ({ withHeader = false, withBackToActionList = true }) => {
  const { t } = useTranslation(['planAction', 'common']);
  const { planActionStatus, selectedOrgUnit } = usePlanActionContext();
  const { minRespondentAmount } = useSurveySettings();

  if (!selectedOrgUnit || !planActionStatus.value) return null;

  return (
    <Stack
      direction="row"
      sx={{ justifyContent: 'space-between', pr: 4, py: 5 }}
    >
      {withHeader && (
        <Box>
          <Typography sx={{ fontSize: 13 }}>
            {t('planAction:Header.ActionPlansFor')}
          </Typography>
          <Typography>
            {`${selectedOrgUnit.name} (${selectedOrgUnit.org_unit_id})`}
          </Typography>
        </Box>
      )}
      <Box>
        <Typography sx={{ fontSize: 13 }}>
          {t('planAction:Header.ResponsibleManager')}
        </Typography>
        <Typography>
          {planActionStatus.value.manager
            ? planActionStatus.value.manager.name
            : t('Header.NoManagerSelected')}
        </Typography>
      </Box>
      <Box>
        <Typography sx={{ fontSize: 13 }}>
          {t('planAction:Header.Email')}
        </Typography>
        <Typography>
          {planActionStatus.value.manager
            ? planActionStatus.value.manager.email
            : '-'}
        </Typography>
      </Box>
      <Box sx={{ position: 'relative' }}>
        <Typography sx={{ fontSize: 13 }}>
          {t('planAction:Header.Priority')}
        </Typography>
        <Box sx={{ position: 'absolute', right: -36, top: -6 }}>
          <FlagRounded
            fontSize="large"
            sx={styles.flag(planActionStatus.value.priority)}
          />
        </Box>
        <Typography>
          {planActionStatus.value.priority ? (
            <span>{t('common:yes')}</span>
          ) : (
            <span>{t('common:no')}</span>
          )}
        </Typography>
      </Box>
      <Box>
        <Typography sx={{ fontSize: 13 }}>
          {t('planAction:Header.Headcount')}
        </Typography>
        <Typography>
          {planActionStatus.value.headcount ||
            `n<${minRespondentAmount}/NegSel`}
        </Typography>
      </Box>
      {withBackToActionList && (
        <Box>
          <Button
            component={Link}
            id="back-to-overview"
            startIcon={<ArrowBackIcon />}
            to={routePaths.PLAN_ACTION_OVERVIEW}
            variant="text"
          >
            {t('BackToActionPlanList')}
          </Button>
        </Box>
      )}
    </Stack>
  );
};

OrgUnitHeader.propTypes = {
  withHeader: PropTypes.bool,
  withBackToActionList: PropTypes.bool,
};

export default OrgUnitHeader;
